<a class="navbar-item" [class.navbar-item-active]="isSettingsPageActive$ | async" (click)="onSettingsMenuClick()">
  <div class="d-flex align-items-center">
    <span class="label">Settings</span>
    <svg-icon class="ml-1" key="caret-down" fontSize="11px"></svg-icon>
  </div>
</a>

<div class="dropdown-menu" [class.d-none]="!menuVisible">
  <ng-container *ngFor="let item of settingsMenuItems$ | async">
    <a
      class="dropdown-menu-option"
      [routerLink]="item.url"
      routerLinkActive="settings-navbar-item-active"
      (click)="onSettingsMenuOptionClick()"
    >
      {{ item.title }}
    </a>
  </ng-container>
</div>
